
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectsList/ProjectsList.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectsList.html');
        
        var script = require('./ProjectsList.ts').default;
        module.exports = require('./ProjectsList.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    